export const getReducer = (ctx) => {
    const getSortDir = (field, sortDirection, sortField) => {
        if (sortField === field) {
            return sortDirection === 'Asc' ? 'Desc' : 'Asc';
        } else {
            return 'Asc';
        }
    };

    const reducer = (state, action) => {
        const resetPaging = {
            page: 0,
            rowsPerPage: 25,
            recOffset: 0,
            isFetching: true,
            listData: [],
        };
        switch (action.type) {
            case 'patch':
                return { ...state, ...action.payload };
            case 'set':
                return action.payload;
            case 'sort':
                return {
                    ...state,
                    ...resetPaging,
                    sortDirection: getSortDir(action.payload.field, state.sortDirection, state.sortField),
                    sortField: action.payload.field,
                    sortString: `${action.payload.field} ${getSortDir(action.payload.field, state.sortDirection, state.sortField)}`,
                    selectedItem: new Set(),
                };
            case 'search':
                return {
                    ...state,
                    ...resetPaging,
                    searchTerm: action.payload.searchTerm,
                    filterString: buildFilterString(state.filters, action.payload.searchTerm, ctx),
                    selectedItem: new Set(),
                };
            case 'toggleIsFetching':
                return { ...state, isFetching: action.payload };
            case 'setListWithHeaders':
                return {
                    ...state,
                    listData: action.payload.listData,
                    tableHeaders: action.payload.tableHeaders,
                    isFetching: false,
                    isInitialized: true,
                    currentCount: action.payload.currentCount || 0,
                    totalRecordCount: action.payload.totalRecordCount,
                    hasMore: action.payload.hasMore,
                    recOffset: action.payload.hasMore ? state.recOffset + 9999 : 0,//#TODO Setting to 9999 was a temporary solution for SHIP-2307, and needs to be either confirmed or replaced with SHIP-2328
                    selectedItem: action?.payload?.selectedItem || new Set(),
                    allChecked: false,
                };
            case 'setListWithoutHeaders':
                const arr = [...state.listData, ...action.payload.listData];
                return {
                    ...state,
                    listData: arr,
                    hasMore: arr.length < state.totalRecordCount,
                    recOffset: arr.length < state.totalRecordCount ? state.recOffset + 9999 : state.recOffset,//#TODO Setting to 9999 was a temporary solution for SHIP-2307, and needs to be either confirmed or replaced with SHIP-2328
                    isFetching: false,
                };
            case 'clearFilters':
                return {
                    ...state,
                    ...resetPaging,
                    filters: action.payload.filters,
                    filterString: buildFilterString(action.payload.filters, state.searchTerm, ctx),
                    selectedItem: new Set(),
                };
            case 'setFilters':
                return {
                    ...state,
                    filters: action.payload.filters,
                    selectedItem: new Set(),
                };
            case 'changeFilters':
                const newFilters = state.filters.map((filter) => {
                    if (filter.label === action.payload.label) {
                        return {
                            ...filter,
                            value: action.payload.value,
                        };
                    } else {
                        return filter;
                    }
                });
                return {
                    ...state,
                    ...resetPaging,
                    filters: newFilters,
                    filterString: buildFilterString(newFilters, state.searchTerm, ctx),
                    selectedItem: new Set(),
                };
            case 'changeTermYear':
                return {
                    ...state,
                    ...resetPaging,
                    term: action.payload.term,
                    selectedItem: new Set(),
                };
            case 'setCachePriority':
                return {
                    useCache: action.payload,
                };
            case 'setStatuses':
                return {
                    ...state,
                    statusRef: action.payload.statusRef,
                };
            case 'setPage':
                return {
                    ...state,
                    page: action.payload.newPage
                };
            case 'setRowsPerPage':
                return {
                    ...state,
                    page: action.payload.newPage,
                    rowsPerPage: action.payload.newRowsPerPage,
                };
            case 'reset':
                return {
                    ...state,
                    ...resetPaging,
                };
            default:
                return state;
        }
    };
    return reducer;
};

//TODO #TechDebt - if there's time look into refactoring this to work on ID, would likely require database work as well.
const formatForSQLString = (string) => `'${string?.replace?.("'", "\\'")}'`;
const formatFoSQLrNumber = (num) => `${num}`;
const getType = (value) => typeof value;
const isString = (value) => getType(value) === 'string';

const getProperValue = (selections) => {
    const formattedValues = selections.map((each, i) => {
        if (isString(each)) {
            if (each === 'Initial') {
                return formatFoSQLrNumber(1);
            }
            if (each === 'Renewal') {
                return formatFoSQLrNumber(2);
            }

            return formatForSQLString(each);
        } else {
            return formatFoSQLrNumber(each);
        }
    });
    return formattedValues.join(',');
};

const buildFilter = (filter) => {
    return `${filter.id} IN (${getProperValue(filter.value)})`;
};

const isLastInArray = (length, index) => length - 1 === index;
const buildSearchFilter = (searchTerm, ctx) => {
    const buildSearchForSingle = (id) => {
        return `${id} LIKE ('%${searchTerm}%')`;
    };

    return `( ${buildSearchForSingle(ctx === 'application' ? 'StudentFirstName' : 'FirstName')} OR ${buildSearchForSingle(ctx === 'application' ? 'StudentLastName' : 'LastName')} OR ${buildSearchForSingle(ctx === 'application' ? 'UniqueID' : 'InvoiceNumber')} )`;
};

const buildFilterString = (filters, searchTerm, ctx) => {
    const hasValueFilters = filters.filter((_filter) => !!_filter?.value?.length);
    if (!hasValueFilters.length && !searchTerm) return '';
    if (searchTerm && !hasValueFilters.length) {
        return buildSearchFilter(searchTerm, ctx);
    }
    const withoutSearchTerm = `${hasValueFilters.map((filter, i) => `${buildFilter(filter)} ${isLastInArray(hasValueFilters.length, i) ? '' : ` AND`}`).join(' ')}`;
    const withSearchTerm = `${withoutSearchTerm} AND ${buildSearchFilter(searchTerm, ctx)}`;
    return !!searchTerm ? withSearchTerm : withoutSearchTerm;
};

